// intersect.js
//
// Общий registry IntersectionObserver для дизайн-системы: ОДИН observer на
// комбинацию threshold+rootMargin, а не по экземпляру на каждый наблюдаемый
// элемент. Сюда вынесено из reveal.plugin.js, чтобы новые скролл-механики
// (v-reveal, v-dock, …) не заводили каждый свой observer.
//
//   observeEl(el, { show(), hide(), once }, { threshold, rootMargin })
//   unobserveEl(el)
//
// show() вызывается когда элемент вошёл во вьюпорт, hide() — когда вышел
// (только если once !== true).

const observers = new Map();
const callbacks = new WeakMap();

function getObserver(threshold, rootMargin) {
  const key = `${threshold}|${rootMargin}`;

  if (!observers.has(key)) {
    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          const cb = callbacks.get(entry.target);
          if (!cb) return;

          if (entry.isIntersecting) {
            cb.show(entry);
            if (cb.once) obs.unobserve(entry.target);
          } else if (!cb.once) {
            cb.hide(entry);
          }
        });
      },
      { root: null, threshold, rootMargin }
    );

    observers.set(key, io);
  }

  return observers.get(key);
}

function observeEl(el, cb, { threshold, rootMargin }) {
  callbacks.set(el, cb);
  getObserver(threshold, rootMargin).observe(el);
}

function unobserveEl(el) {
  callbacks.delete(el);
  observers.forEach(io => io.unobserve(el));
}

function prefersReducedMotion() {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

export { getObserver, observeEl, unobserveEl, prefersReducedMotion };
